import React, { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import ModalLyt from "../../../components/Layouts/ModalLyt/ModalLyt";
import KrDetails from "../LComponents/KrDetails/KrDetails";
import KrActions from "../LComponents/KrActions/KrActions";
import {
  useGetAlignmentMeetingDetailByTeamId,
  useGetWebObjectiveDetailsCheckinMeetingByTeamId2,
} from "../../Meeting/Hooks/index";
import {
  useGetKeyResultMeetingHistory,
  useDisLikeMeeting,
  useLikeMeeting,
} from "../Hooks/index";
import KrHistoryModalContent from "../LComponents/KrHistoryModalContent/KrHistoryModalContent";
import {
  ObjectiveSelectedFace,
  krSelectedFace,
} from "../Interfaces/interfaces";
import DyDataGridObj from "../../../components/GlobalComponents/DyDataGridObj/DyDataGridObj";
import { useSelector } from "react-redux";
import { EmptyDataIcon } from "../StataicData/index";
import MyTeamsNavigations from "../LComponents/MyTeamsNavigation/MyTeamsNavigations";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DYToastMessage from "../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
// import TenantImageSelector from '../../../components/GlobalComponents/ImageTenantSelector/ImageAttachment';
// import smil from "../../../Asset/Svgs/Emojys/smil.png";
// import meh from "../../../Asset/Svgs/Emojys/meh.png";
// import sad from "../../../Asset/Svgs/Emojys/sad.png";
import { changeTreeViewStateR } from "../../Meeting/MeetingsSlice/MeetingsSlice";
import { useDispatch } from "react-redux";
// import AddMeetingSuccess from "../../Meeting/LComponents/AddMeetingSuccess/AddMeetingSuccess";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import TrendingDownIcon from "@mui/icons-material/TrendingDown";
// import DyLoadingCircular from "../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
import { CircularProgress } from "@mui/material";
import { CreateKReval } from "../LComponents/Forms/CreateKReval/CreateKReval";
// import LikeIcon from "@mui/icons-material/Favorite";
import LyBackdrop from "../../../components/Layouts/BackDrop/BackDrop";
import "../../CompanyManagment/Copmonents/Like/Like.css";
// import { disLikeMeeting, likeMeeting } from "../Api";
import { NewUseStore } from "../../../Store/newUseStore";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { thousandSeparator } from "../../../helper/lib";
import CommentModal from "../../TenantDash/LComponents/AllTenantDash/AnotherComponent ";
import { CreateAttachment } from "../LComponents/Forms/CreateAttachment/CreateAttachment";
import { CreateAttachmentObj } from "../LComponents/Forms/CreateAttachmentObj/CreateAttachmentObj";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AlignmentKrCart from "../LComponents/AlignmentKrCart/AlignmentKrCart";
const AlignmentObjectiveKeyResults: React.FC<any> = ({ personPicture} : any) => {
  const dispatch = useDispatch();
  const treeView = useSelector(
    (state: any) => state.meetings.treeViewState?.treeView
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const personId=useSelector((state:any)=>state.loign.personId);
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  //NADERI const nodeId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
  //NADERI
  const [objectivies, setObjectivies] = useState([]);
  const nodeId = NewUseStore((state) => state.newCompanyId);
  const [objectiveSelectedData, setObjectiveSelectedData] = useState<any>(null);
  const [objectiveManiInfo, setObjectiveMainInfo] =
    useState<ObjectiveSelectedFace | null>(null);
  const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [keyR, setKeyR] = useState<any>([]);
  const [objId, setObjeId] = useState<any>();

  const getObjectiveSuccess = (data: any) => {
    if (data && data.length > 0) {
      setObjectivies(data);
      const selectedRow = objectiveSelectedData
        ? (data.find((item: any) => item.id === objectiveSelectedData.id) ||
          data[0])
        : data[0];
      setRowSelectedData(selectedRow);
      let { name, id } = selectedRow;
      let ObjSelected = {
        name: name,
        id: id,
      };
      
      setObjectiveMainInfo(ObjSelected);
      //setObjectiveSelectedData(data[0]);
      let keyrs = (selectedRow as any).keyResultCheckingMeetingQueryResultDto
        ? (selectedRow as any).keyResultCheckingMeetingQueryResultDto
        : [];
      const keyRTmp = keyrs.map((item: any) => ({
        ...item,
        oldValue: thousandSeparator(item.oldValue),
        oneValue: thousandSeparator(item.oneValue),
        sevenTenthsValue: thousandSeparator(item.sevenTenthsValue),
        threeTenthsValue: thousandSeparator(item.threeTenthsValue),
        startValue: thousandSeparator(item.startValue),
        currentValue: thousandSeparator(item.currentValue),
      }));
      setKeyR(keyRTmp);
      setObjSelectionModel((selectedRow as any).id);
    }
    setSuccessState(false);
  };

  const getObjectiveError = () => {};

  const {
    data,
    isError: getObjectiveErrorFlag,
    isFetched: getObjectiveAgainFetched,
    isLoading: getObjLoading,
    refetch: callAgain,
  } = useGetAlignmentMeetingDetailByTeamId(
    getObjectiveSuccess,
    getObjectiveError,
    nodeId,
    priodId,
    meetingId
  );

  //
  const companyNode: any = useSelector(
    (state: any) => state.meetings.companyList
  );
  const KRinitialStatee = useSelector(
    (state: any) => state.loign.kRinitialState
  );
  const ObjctivieInitialState = useSelector(
    (state: any) => state.loign.ObjctivieInitialState
  );

  // const objectivies1 = useSelector((state: any) => state.meetings.objectivie);
  const objUpdated = useSelector((state: any) => state.meetings.objUpdated);
  const teamInfo = useSelector((state: any) => state.meetings.teamInfo);

  // const [teameInfo, setTeameInfo] = useState(null);
  // const [teameInfoo, setTeameInfoo] = useState(
  //   teameInfo ? teameInfo : teamInfo
  // );
  const [showModal, setShowModal] = useState(false);
  const [justMyKr, setJustMyKr] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [showAttachment1, setShowAttachment1] = useState(false);
  const [krRowData, setKrRowData] = useState(null);
  const [showToolbarModal, setShowToolbarModal] = useState<Boolean | null>(
    false
  );
  // const [addEvalSuccessModal, setAddEvalSuccessModal] =
  //   useState<Boolean | null>(false);
  const [showAddEvalModal, setShowAddEvalModal] = useState<Boolean>(false);
  const [ShowActionsModal, setShowActionsModal] = useState<Boolean>(false);
  const [pointingSystem, setPointingSystem] = useState<string | null>(null);
  const { mutate: likeMeeting, data: likeData } = useDisLikeMeeting();
  const { mutate: disLikeMeeting, data: disLikeData } = useLikeMeeting();
  const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
  const [rowSelectedData, setRowSelectedData] = useState<any>(null);

  const [krMainInfo, setKrMainInfo] = useState<krSelectedFace | null>(null);
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);

  // const[object]
  // const getObjectiveSuccess = () => {};
  // const getObjectiveError = () => {};

  // const {
  //   data: objectiveData,
  //   isError: getObjectiveErrorFlag,
  //   isFetched: getObjectiveAgainFetched,
  //   isLoading: getObjLoading,
  //   refetch: callAgain,
  // } = useGetWebObjectiveDetailsCheckinMeetingByTeamId2(
  //   getObjectiveSuccess,
  //   getObjectiveError,
  //   nodeId,
  //   priodId,
  //   meetingId
  // );

  const [objectivee, setObjectivee] = useState<any>(
    objectivies?.length > 4 ? "fb7cc4ea-7162-4916-9aa8-834b14308e10" : null
  );

  // useEffect(() => {
  //   if (!nodeId) window.location.reload();
  // }, []);

  useEffect(() => {
    if (justMyKr) {
      setMyKeysResultsList();
      renderContents();
    }else{
      setKeysResultsList();
      renderContents();
    }
  }, [justMyKr]);

  // const refreshGrid = () => {
  //   renderContents();
  // };

  useEffect(() => {
    // if (getObjectiveAgainFetched)
    //   console.log("first"); //setSuccessState(false);
    if (!getObjectiveAgainFetched) {
      setObjectivies([]);
      setJustMyKr(false);
      setKeyR([]);
      setObjectiveMainInfo(null);
    } 
  }, [getObjectiveAgainFetched]);

  useEffect(() => {
    if (addEvalAsyncData) {
      callAgain();
      setSuccessState(true);
    }
  }, [addEvalAsyncData]);

  const [objcSelectionModel, setObjSelectionModel] = useState<string | any>(
    localStorage.getItem("objcSelectionModel")
  );
  const [krSelectionModel, setKrSelectionModel] = useState<string | any>(
    localStorage.getItem("krSelectionModel")
  );

  const [getCustomerBody, setGetCustomerBody] = useState<any>({
    pageSize: 50000,
    page: 1,
    searchTerm: "",
  });
  const [krId, setKrId] = useState(null);
  const {
    data: KrHistoryData,
    isLoading: KRHLoading,
    isError: KRHError,
    isFetched: KRHFetched,
  } = useGetKeyResultMeetingHistory(krId, priodId, meetingId);

  useEffect(() => {
    if (objectiveSelectedData) {
      // console.log(objectiveSelectedData)
      let { name, id } = objectiveSelectedData;
      let ObjSelected = {
        name: name,
        id: id,
      };
      setObjeId(id);
      setObjectiveMainInfo(ObjSelected);
    }

    // objectiveManiInfo,setObjectiveMainInfo
  }, [objectiveSelectedData]);

  ///NADERi
  // useEffect(() => {
  //   if (objectivies && objectivies.length > 0) {
  //     setRowSelectedData(objectivies[0]);
  //     setObjectiveSelectedData(objectivies[0]);
  //     let keyrs = (objectivies[0] as any)
  //       .keyResultCheckingMeetingQueryResultDto;
  //     setKeyR(keyrs);
  //     setObjSelectionModel((objectivies[0] as any).id);
  //     setSuccessState(false);
  //     // setKrSelectionModel(objectivies[0].id);
  //   }
  // }, [objectivies]);
  ///NADERI
  useEffect(() => {
    localStorage.setItem("krSelectionModel", krSelectionModel);
    // console.log(localStorage.getItem("krSelectionModel"));
  }, [krSelectionModel]);

  useEffect(() => {
    localStorage.setItem("objcSelectionModel", objcSelectionModel);
  }, [objcSelectionModel]);

  useEffect(() => {
    const krSelectionModel = localStorage.getItem("krSelectionModel");
    // console.log(krSelectionModel)
    if (krSelectionModel) {
      setKrSelectionModel(krSelectionModel);
    }
  }, [addEvalAsyncData]);

  //NADERI useEffect(() => {
  //   const objcSelectionModel = localStorage.getItem("objcSelectionModel");
  //   // console.log(objcSelectionModel);
  //   // const storedAge = localStorage.getItem('age');

  //   if (krSelectionModel) {
  //     setObjSelectionModel(objcSelectionModel);
  //   }
  // }, [addEvalAsyncData]);
  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [showImageSelector, setShowImageSelector] = useState<boolean>(false);
  const handleImageChange = (newImgSrc: string) => {
    setImgSrc(newImgSrc);
    localStorage.setItem('tenantImage', newImgSrc); // Save to localStorage
    setShowImageSelector(false);
  };
  const handleToastMessage = (message: string) => {
    setShowToastMessage(true);
    setTimeout(() => setShowToastMessage(false), 3000); // Hide toast after 3 seconds
  };

  const handleImageSelectorClose = () => {
    setShowImageSelector(false);
  };

  useEffect(() => {
    if (rowSelectedData) {
      let {
        name,
        id,
        responsibleName,
        startDate,
        startValue,
        threeTenthsValue,
        sevenTenthsValue,
        oneValue,
        currentValue,
        problems,
        predict,
        currentStateValue,
        description,
        score,
        revenue,
        attachment,
        revenueTwo,
        okR_KeyResultType,
      } = rowSelectedData;
      let krSelected: krSelectedFace = {
        name: name,
        id: id,
        responsibleName: responsibleName,
        startDate: startDate,
        startValue: startValue,
        threeTenthsValue: threeTenthsValue,
        sevenTenthsValue: sevenTenthsValue,
        oneValue: oneValue,
        attachment:attachment,
        currentValue: currentValue,
        problems: problems,
        nextState: predict,
        currentState: currentStateValue,
        description: description,
        score: score,
        revenue: revenue,
        revenueTwo: revenueTwo,
        okR_KeyResultType: okR_KeyResultType,
      };
      setKrMainInfo(krSelected);
      // console.log(rowSelectedData)
    }
  }, [rowSelectedData]);
  const [likec, setLikeCount] = useState<number>(25);
  const [activeBtn, setActiveBtn] = useState<string>("none");
  const initialLikeMeeting = () => {
    let deleteBody = {
      // objectiveId:id,
      tenantId: tenantId,
      meetingId: meetingId,
    };
    likeMeeting(deleteBody);
  };

  const initialDisLikeMeeting = () => {
    let deleteBody = {
      // objectiveId:id,
      tenantId: tenantId,
      meetingId: meetingId,
    };
    disLikeMeeting(deleteBody);
  };

  const handleReactionClick = (reaction: string): void => {
    if (activeBtn === "none") {
      // if (reaction === "dislike") {
      //   setdisLikeCount(dislikeCount + 1);
      //   setActiveBtn("disLike");
      // } else
      if (reaction === "like") {
        setLikeCount(likec + 1);
        setActiveBtn("like");
        initialLikeMeeting();
      }
    } else if (activeBtn === reaction) {
      // if (reaction === "dislike") {
      //   setdisLikeCount(dislikeCount - 1);
      // } else
      if (reaction === "like") {
        setLikeCount(likec - 1);
        initialDisLikeMeeting();
      }
      setActiveBtn("none");
    } else if (activeBtn !== reaction) {
      // if (reaction === "dislike") {
      //   setdisLikeCount(dislikeCount + 1);
      //   setLikeCount(likeCount - 1);
      //   setActiveBtn("dislike");
      // } else
      if (reaction === "like") {
        // setdisLikeCount(dislikeCount + 1);
        // setdisLikeCount(dislikeCount - 1);
        setActiveBtn("like");
      }
    }
  };

  const handleComment= (id: string, name : string): void => {
    <CommentModal id={id} name={name} />
  };

  const objectiveColumns: any = [
    {
      field: "rowid",
      headerName: "ردیف",
      width: 35,

      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) =>
        params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "name",
      align: "left",
      headerName: "شرح هدف",
      headerAlign: "center",
      sortable: false,
      // wrap: "wrap",
      // minWidth: 350,
      flex:1,
      fontsize: "12px !important",
      renderCell: ({ value }: any) => {
        return (
          <Box>
            {value.length > 40 ? (
              <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                {value}
              </Tooltip>
            ) : (
              <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
            )}
          </Box>
        );
      },
    },

    {
      field: "responsibleName",
      headerName: "مسئول",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 170,
    },

    {
      field: "keyResultCount",
      headerName: "تعداد  نتایج",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 100,
    },

    {
      field: "objectivesStateName",
      headerName: "وضعیت هدف",
      sortable: false,
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ value }: any) => {
        return (
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={value === "فعال" ? "#D5F7D4" : "#E5F1FF"}
          >
            <Typography fontSize={"0.8rem"} px={8}>
              {value}
            </Typography>
          </Box>
        );
      },
    },

    {
      field: "weight",
      headerName: "وزن",
      sortable: false,
      hideable: true,
      hide: true,
      headerAlign: "center",
      align: "center",
      width: 80,
    },
    // {
    //   field: "evaluationPercentage",
    //   headerName: "درصد ارزیابی",
    //   align: "center",
    //   sortable: false,
    //   headerAlign: "center",
    //   width: 120,
    // },
    // {
    //   field: "oldScore",
    //   headerName: "امتیاز قبلی",
    //   align: "center",
    //   sortable: false,
    //   headerAlign: "center",
    //   width: 75,
    //   renderCell: (par: any) => {
    //     let value: number = par?.row?.oldScore;

    //     //  console.log(par.row.score)
    //     let color = "";
    //     let fColor = "";
    //     switch (true) {
    //       case value >= 70:
    //         color = "#D5F7D4";
    //         fColor = "#125610";
    //         break;
    //       case value < 70 && value > 30:
    //         color = "#FFF8D0";
    //         fColor = "#6B6440";
    //         break;
    //       default:
    //         color = "#FFEEE5";
    //         fColor = "#993600";
    //         break;
    //     }
    //     return (
    //       <Box
    //         m={3}
    //         borderRadius={2}
    //         width={"100%"}
    //         display={"flex"}
    //         justifyContent={"center"}
    //         alignItems={"center"}
    //         height={"75%"}
    //         bgcolor={color}
    //       >
    //         <Typography
    //           px={8}
    //           color={fColor}
    //           fontSize={"0.8rem"}
    //           fontWeight={400}
    //         >
    //           {value}
    //         </Typography>
    //       </Box>
    //     );
    //   },
    // },
    // {
    //   field: "score",
    //   headerName: "امتیاز جدید",
    //   align: "center",
    //   sortable: false,
    //   headerAlign: "center",
    //   width: 75,
    //   renderCell: (par: any) => {
    //     let value: number = par?.row?.score;

    //     //  console.log(par.row.score)
    //     let color = "";
    //     let fColor = "";
    //     switch (true) {
    //       case value >= 70:
    //         color = "#D5F7D4";
    //         fColor = "#125610";
    //         break;
    //       case value < 70 && value > 30:
    //         color = "#FFF8D0";
    //         fColor = "#6B6440";
    //         break;
    //       default:
    //         color = "#FFEEE5";
    //         fColor = "#993600";
    //         break;
    //     }
    //     return (
    //       <Box
    //         m={3}
    //         borderRadius={2}
    //         width={"100%"}
    //         display={"flex"}
    //         justifyContent={"center"}
    //         alignItems={"center"}
    //         height={"75%"}
    //         bgcolor={color}
    //       >
    //         <Typography
    //           px={8}
    //           color={fColor}
    //           fontSize={"0.8rem"}
    //           fontWeight={400}
    //         >
    //           {value}
    //         </Typography>
    //       </Box>
    //     );
    //   },
    // },
    // {
    //   // name:'startDate',
    //   field: "difference",
    //   headerName: "تفاوت",
    //   align: "center",
    //   sortable: false,
    //   headerAlign: "center",
    //   width: 100,
    //   renderCell: (param: any) => {
    //     let difference: string = param?.row?.difference;
    //     let postive;
    //     if (difference  && difference !== '0' && difference !== "-") {
    //       postive = difference.includes("-");
    //       return (
    //         <Box
    //           display={"flex"}
    //           alignItems={"center"}
    //           justifyContent={"center"}
    //           columnGap={1}
    //         >
    //           <Typography fontSize={"0.6rem"}>
    //             {difference.replace("-", "")}
    //           </Typography>

    //           {!postive ? (
    //             <TrendingUpIcon color="secondary" />
    //           ) : (
    //             <TrendingDownIcon color="error" />
    //           )}
    //         </Box>
    //       );
    //     } else if (difference && difference !== '0' ) {
    //       return (
    //         <Box
    //           display={"flex"}
    //           alignItems={"center"}
    //           justifyContent={"center"}
    //           columnGap={1}
    //         >
    //           <Typography fontSize={"0.6rem"}>{difference}</Typography>
    //         </Box>
    //       );
    //     } else {
    //       return (
    //         <Typography fontSize={"0.6rem"} /*color={"red"}*/>
    //           {difference}
    //         </Typography>
    //       );
    //     }
    //   },
    // },
    {
      field: "comment",
      headerName: "نظرات",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      fontsize: "14px",
      renderCell: ( par : any) => {
        if(par !== undefined && par !== null){
        let idd: string = par?.row?.id;
        let namee: string = par?.row?.name;
        let commentCount: number = par?.row?.commentCount;
        return (
          <Box display={"flex"} justifyContent={"end"}>
          <CommentModal id={idd} name={namee} meetingId={meetingId} commentCount={commentCount} />
          </Box>
      )
        }
      },
    },
    // {
    //   field: "commentCount",
    //   headerName: "تعداد نظرات",
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: false,
    //   minWidth: 60,
    //   fontsize: "14px",
    // },
    // {
    //   field: "like",
    //   headerName:  <LikeIcon color="error" /> ,
    //   align: "center",
    //   sortable: false,
    //   headerAlign: "center",
    //   width: 100,

    //   renderCell: (par: any) => {
    //     return (
    //       <Box
    //         m={2}
    //         borderRadius={2}
    //         width={"100%"}
    //         display={"flex"}
    //         justifyContent={"center"}
    //         alignItems={"center"}
    //         height={"95%"}
    //         bgcolor={'#d7dbd8'}
    //       >

    //           {
    //              <button
    //              className={`bttn ${activeBtn === "like" ? "like-acttive" : ""}`}
    //              onClick={() => handleReactionClick("like")}
    //            >
    //               <LikeIcon fontSize="small"/>{54}
    //            </button>
    //           }
    //       </Box>
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    if (justMyKr) {
      setMyKeysResultsList();
      renderContents();
    }else{
      setKeysResultsList();
      renderContents();
    }
  }, [objectivee]);

  const setKeysResultsList = (): any => {
    let keyrs = objectivee?.keyResultCheckingMeetingQueryResultDto;
    const keyRTmp =
      keyrs &&
      keyrs.map((item: any) => ({
        ...item,
        oldValue: thousandSeparator(item.oldValue),
        oneValue: thousandSeparator(item.oneValue),
        sevenTenthsValue: thousandSeparator(item.sevenTenthsValue),
        threeTenthsValue: thousandSeparator(item.threeTenthsValue),
        startValue: thousandSeparator(item.startValue),
        currentValue: thousandSeparator(item.currentValue),
      }));
    setKeyR(keyRTmp);
  };

  const setMyKeysResultsList = (): any => {
    let keyrs = objectivee?.keyResultCheckingMeetingQueryResultDto;
    const keyRTmp =
      keyrs &&
      keyrs
        .filter((item: any) => item.responsibleId === personId)  
        .map((item: any) => ({
          ...item,
          oldValue: thousandSeparator(item.oldValue),
          oneValue: thousandSeparator(item.oneValue),
          sevenTenthsValue: thousandSeparator(item.sevenTenthsValue),
          threeTenthsValue: thousandSeparator(item.threeTenthsValue),
          startValue: thousandSeparator(item.startValue),
          currentValue: thousandSeparator(item.currentValue),
        }));
    setKeyR(keyRTmp);
  };

  const renderContents = () => {
    if (!keyR && !getObjLoading) {
      return (
        <Box
          width={"50%"}
          mx={"auto"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <EmptyDataIcon style={{ width: "80px", height: "80px" }} />
          <Typography mt={2} color={"blue"} textAlign={"center"}>
            برای نمایش نتایج کلیدی از جدول بالا یک هدف را انتخاب نمایید.
          </Typography>
        </Box>
      );
    } else {
      return (
        <Grid item xs={12}>
          <Grid container>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-around"}
            >
              <Box  px={3} display={"flex"} flexDirection={"row-reverse"}>
                <Box display={"flex"} flexDirection={"row"}>
                  {/* <Typography fontSize={"13px"} fontWeight={700}>
                    هدف: {objectivee?.name}
                  </Typography> */}
                </Box>
              </Box>
              <Box  px={3}>
                {/* <Typography fontSize={"13px"} fontWeight={700}>
                  مسئول هدف: {objectivee?.responsibleName}
                </Typography> */}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {/* {!getObjLoading && (
              // <DyDataGrid
              //   data={keyR || []}
              //   columns={keyResultColumn || []}
              //   initialOnRowClick={setKrRowData}
              //   hideFooter={true}
              //   setSelectionModel={setKrSelectionModel}
              //   selectionModel={krSelectionModel}
              //   initState={KRinitialStatee}
              //   additionalToolbar={true}
              //   setShowHistory={setHistoryModal}
              //   setShowAttachment={setShowAttachment}
              //   setSpecialId={setKrId}
              //   setShowInformation={setShowModal}
              //   setShowAddEvalModal={setShowAddEvalModal}
              //   setShowActionsModal={setShowActionsModal}
              //   initialMount={true}
              //   setPointSys={setPointingSystem}
              //   drName={"KRinitialState"}
              //   setRowSelectedData={setRowSelectedData}
              // />

            )} */}
          </Grid>
          <Grid item xs={12} >
                <Grid container spacing={1}>
                  {!getObjLoading && keyR && 
                    keyR.map((item: any, i: number) => {
                      return (
                        <Grid item xs={12} sm={12}>
                          <Box
                              key={i}
                              sx={{
                                // transition: "all 0.3s ease",
                                // "&:hover": {
                                //   transform: "scale(1.05)",
                                //   backgroundColor: "withesmoke",
              
                                // },
                                //backgroundColor: "gray",
                              }}
                            >
                            <AlignmentKrCart
                              setKrId={setKrId} 
                              meetingId={meetingId}
                              setShowToastMessage={setShowToastMessage}
                              personPicture={personPicture}
                              item={item}
                            />
                          </Box>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
        </Grid>
      );
    }
  };

  return (
    <>
      <Grid container sx={{ bgcolor: "#F9F9F9" }} style={{ width: "100%" }}>
        <Grid item xs={treeView ? 12 : 10}>
          <Box py={1} my={0.5} borderRadius={1} boxShadow={1} bgcolor={"white"}>
            <Grid container>
              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >
                    {teamInfo.isCompany ? "نام شرکت:" : "نام تیم:"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.name}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >
                    {teamInfo.isCompany ? "مدیر شرکت:" : "مدیر تیم:"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.managerCompanyName}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >{`تعداد اهداف ${
                    teamInfo.isCompany ? "شرکت:" : "تیم:"
                  }`}</Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.objectivesCount}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >{`تعداد نتایج ${
                    teamInfo.isCompany ? "شرکت:" : "تیم:"
                  }`}</Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.keyResultsCount}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {!treeView && (
          <Grid
            mx={"auto"}
            item
            xs={12}
            sm={1.7}
            display={"flex"}
            alignItems={"center"}
          >
            <Grid container borderRadius={2} boxShadow={1}>
              {/* <Grid item xs={10}  >
                <Box py={1} display={'flex'} alignItems={'center'} justifyContent={'center'}  >
                  <Typography fontSize={'10px'}  >برای پیمایش تیم ها ورق بزنید</Typography>
                </Box>
              </Grid> */}
              <Grid item xs={9} my={"auto"}>
                <MyTeamsNavigations />
              </Grid>
              <Grid item xs={3} py={1}>
                <IconButton
                  size="small"
                  onClick={() => {
                    dispatch(changeTreeViewStateR());
                  }}
                >
                  <AccountTreeIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Box width={"100%"} borderRadius={2} boxShadow={2} bgcolor={"white"}>
          <Grid item xs={12}>
            <Typography
              px={3}
              py={1}
              textAlign={"left"}
              fontSize={"16px"}
              color={"#00387C"}
              fontWeight={800}
            >
              لیست اهداف
            </Typography>
            {!getObjLoading && objectivies && objectivies.length > 0 ? (
              <DyDataGridObj
                initialOnRowClick={setObjectivee}
                data={objectivies}
                columns={objectiveColumns || []}
                hideFooter={true}
                setRowSelectedData={setObjectiveSelectedData}
                objcSelectionModel={objcSelectionModel}
                setSelectionModel={setObjSelectionModel}
                selectionModel={objcSelectionModel}
                initState={ObjctivieInitialState}
                setShowAttachment={setShowAttachment1}
                initialMount={true}
                additionalToolbar={true}
                setSpecialId={setObjeId}
                drName={"ObjctivieInitialState"}
              />
            ):
            <DyDataGridObj
                initialOnRowClick={setObjectivee}
                data={[]}
                columns={objectiveColumns || []}
                hideFooter={true}
                setRowSelectedData={setObjectiveSelectedData}
                objcSelectionModel={objcSelectionModel}
                setSelectionModel={setObjSelectionModel}
                selectionModel={objcSelectionModel}
                initState={ObjctivieInitialState}
                setShowAttachment={setShowAttachment1}
                initialMount={true}
                additionalToolbar={true}
                setSpecialId={setObjeId}
                drName={"ObjctivieInitialState"}
              />}
          </Grid>
        </Box>

        <Box
          // bgcolor={'red'}
          mt={0.5}
          width={"100%"}
          borderRadius={3}
          boxShadow={2}
          bgcolor={"white"}
          // rowGap={1}
        >
          <Grid item xs={12}>
            <Typography
              px={3}
              fontSize={"16px"}
              py={0.5}
              textAlign={"left"}
              variant="h6"
              color={"#00387C"}
              fontWeight={800}
            >
              لیست نتایج کلیدی
            </Typography>
          </Grid>

          <Grid item xs={12} >
          <Box py={1} px={3}>
              {/* <label className="flex gap-x-2 w-1/6 items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="IsKR"
                            value="IsKR"
                            id="IsKR"
                            defaultChecked={true}
                            onChange={() =>
                              justMyKr === false ? setJustMyKr(true) :setJustMyKr(false) 
                            }
                            checked={
                              justMyKr
                            }
                          />
                          <Typography fontSize={"13px"} fontWeight={700}>
                            نتایج من
                            </Typography>
               </label> */}
              </Box>
            <Grid container>{renderContents()}</Grid>
          </Grid>
        </Box>
        {showModal && krRowData && (
          <ModalLyt
            title={"هدف: " + objectivee?.name}
            width={600}
            showModal={Boolean(showModal)}
            setShowModal={setShowModal}
          >
            <KrDetails
              // krDetail={krRowData}
              data={krRowData}
              // objcSelectionModel={objcSelectionModel}
            />
          </ModalLyt>
        )}

        {historyModal && (
          <ModalLyt
            //  loadingFlag={KRHLoading}
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"تاریخچه نتیجه کلیدی"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <KrHistoryModalContent
              // loadingFlag={KRHLoading}
              // data={KrHistoryData}
              krDetail={krRowData}
              objective={objectivee}
              meetingId={meetingId}
              priodId={priodId}
              krId={krId}
            />
          </ModalLyt>
        )}

        {showAttachment && (
          <ModalLyt
            //  loadingFlag={KRHLoading}
            title={"ضمیمه"}
            showModal={Boolean(showAttachment)}
            setShowModal={setShowAttachment}
          >
              <CreateAttachment
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              meetingId={meetingId}
              setChangeImgData={handleImageChange}
              onClose={handleImageSelectorClose}
              // pointingSystem={pointingSystem}
              objectiveId={objectivee?.id}
              kresultId={krId}
              // afterAddKr={initialAfterAddKr}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
            {/* <TenantIm
              // loadingFlag={KRHLoading}
              // data={KrHistoryData}
              krDetail={krRowData}
              objective={objectivee}
              meetingId={meetingId}
              priodId={priodId}
              krId={krId}
            /> */}
          </ModalLyt>
        )}

{showAttachment1 && (
          <ModalLyt
            //  loadingFlag={KRHLoading}
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ضمیمه"}
            showModal={Boolean(showAttachment1)}
            setShowModal={setShowAttachment1}
          >
              <CreateAttachmentObj
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              setChangeImgData={handleImageChange}
              onClose={handleImageSelectorClose}
              // pointingSystem={pointingSystem}
              objectiveId={objectivee?.id}
              kresultId={objId}
              // afterAddKr={initialAfterAddKr}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
            {/* <TenantIm
              // loadingFlag={KRHLoading}
              // data={KrHistoryData}
              krDetail={krRowData}
              objective={objectivee}
              meetingId={meetingId}
              priodId={priodId}
              krId={krId}
            /> */}
          </ModalLyt>
        )}

        {ShowActionsModal && (
          <ModalLyt
            //  loadingFlag={KRHLoading}
            width={1100}
            title={"تعهدات"}
            showModal={Boolean(ShowActionsModal)}
            setShowModal={setShowActionsModal}
          >
            <KrActions
              loadingFlag={KRHLoading}
              data={KrHistoryData}
              krDetail={krRowData}
              objective={objectivee}
              isBAU={false}
              // data={krRowData}
            />
          </ModalLyt>
        )}

        {showAddEvalModal && (
          <ModalLyt
            // width={1300}
            width={isMobile ? '350px' : '1300px'}  // در موبایل 350px و در سایر اندازه‌ها 600px

            title={"تعیین مقدار برای نتیجه کلیدی"}
            showModal={Boolean(showAddEvalModal)}
            setShowModal={setShowAddEvalModal}
          >
            {/* afterAddKr */}
            {/* <AddKrEvaluation
              cancelo={setShowAddEvalModal}
              objectiveId={objectivee?.id}
              kresultId={krId}
              onsucces={setSuccessState}
              pointingSystem={pointingSystem}
              afterAddKr={initialAfterAddKr}
              rowSelectedData={rowSelectedData}
            /> */}

            <CreateKReval
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              // pointingSystem={pointingSystem}
              objectiveId={objectivee?.id}
              kresultId={krId}
              // afterAddKr={initialAfterAddKr}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
          </ModalLyt>
        )}

        {showToolbarModal && (
          <ModalLyt
            title={"نتیجه کلی"}
            showModal={Boolean(showToolbarModal)}
            setShowModal={setShowToolbarModal}
          >
            {/* <h1>ModaLOfDatagRid</h1> */}
          </ModalLyt>
        )}

        {SuccessState && (
          <LyBackdrop
            visible={SuccessState}
            // successFlag={getObjectiveAgainFetched}
          >
            <Box>
              <CircularProgress color="inherit" />
            </Box>
          </LyBackdrop>
        )}

        {showToastMessage && (
          <DYToastMessage
            isSuccess={addEvalAsyncData?.isSuccess}
            message={addEvalAsyncData?.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}

        {/* const[showToastMessage,setShowToastMessage]=useState<any>(false);
  const[addEvalAsyncData,setAddEvalAsyncData]=useState<any>(null); */}
      </Grid>
    </>
  );
};

export default AlignmentObjectiveKeyResults;
